export default __webpack_public_path__ + "static/media/engagement.6e35ef3f.png";